// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Models
import { AssetViewModel } from '../../string/models/string-view.model';
import { Job } from '../models/job.model';
import { AppCleanup } from '../../../../shared/models';

@Injectable({
	providedIn: 'root',
})
export class BopService extends AppCleanup {
	private readonly bopUrl: string;
	private readonly assetUrl: string;

	constructor(private http: HttpClient) {
		super();
		this.assetUrl = `${this.apiUrl}api/asset`;
		this.bopUrl = `${this.assetUrl}/bop`;
	}

	getBops() {
		return this.http.get<AssetViewModel[]>(this.bopUrl);
	}

	getBop(id: number) {
		return this.http.get<AssetViewModel>(`${this.bopUrl}/${id}`);
	}

	getBopParentUnits() {
		return this.http.get<any[]>(`${this.bopUrl}/parentUnit`);
	}

	getJobsForBop(assetNumber: string) {
		return this.http.get<Job[]>(`${this.assetUrl}/${assetNumber}/jobs`);
	}

	updateBop(model: BopUpdateModel) {
		return this.http.post<AssetViewModel>(`${this.apiUrl}api/updatesalesforceasset`, model);
	}
}

export class BopUpdateModel {
	SfId: string;
	ParentAssetName: string;
}
